export const incident_progress_methods = {
  get_incident_progress_history(report) {
    return Array.isArray(report?.progress_history) ? report.progress_history : [];
  },
  get_upcoming_incident_progress_steps(report) {
    const stages = [
      { key: "pending", label: "Under Review" },
      { key: "assigned", label: "Assigned" },
      { key: "in_progress", label: "In Progress" },
      { key: "resolved", label: "Resolved" },
    ];
    const current_status = String(report?.incident_status?.name || "pending")
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
    const current_index = stages.findIndex((stage) => stage.key === current_status);

    return current_index < 0
      ? []
      : stages.slice(current_index + 1).reverse();
  },
  get_incident_progress_user_name(user, fallback = "System") {
    if (!user) return fallback;
    const generated_name = [user.first_name, user.last_name].filter(Boolean).join(" ");
    return user.full_name || generated_name || user.email || fallback;
  },
  get_incident_progress_actor(progress) {
    return this.get_incident_progress_user_name(progress?.updated_by);
  },
  get_incident_progress_status_label(status) {
    return String(status?.name || "")
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  },
  get_incident_progress_title(progress) {
    const current_status = this.get_incident_progress_status_label(progress?.status);
    const previous_status = this.get_incident_progress_status_label(progress?.previous_status);
    const assigned_to = this.get_incident_progress_user_name(
      progress?.assigned_to,
      "an administrator",
    );
    const previous_assignee = this.get_incident_progress_user_name(
      progress?.previous_assignee,
      "an administrator",
    );

    if (progress?.action_type === "reported") return "Reported";
    if (progress?.action_type === "status_changed" && progress?.status?.name === "pending" && !progress?.previous_status) {
      return "Under Review";
    }
    if (progress?.action_type === "assigned") return `Assigned to ${assigned_to}`;
    if (progress?.action_type === "reassigned") {
      return `Reassigned from ${previous_assignee} to ${assigned_to}`;
    }
    if (progress?.action_type === "unassigned") return `Unassigned from ${previous_assignee}`;
    if (previous_status && previous_status !== current_status) {
      return `${previous_status} → ${current_status}`;
    }
    return current_status || "Status updated";
  },
};
